// Import and register all your controllers
import { application } from "./application";
import AutoDismissController from "./auto_dismiss_controller";
import CalendarModalController from "./calendar_modal_controller";
import CircleManagerController from "./circle_manager_controller";
import ContactPickerController from "./contact_picker_controller";
import MembersModalController from "./members_modal_controller";
import ContactFormController from "./contact_form_controller";
import CustomLinksController from "./custom_links_controller";
import FilterModalController from "./filter_modal_controller";
import HelloController from "./hello_controller";
import InteractionFormController from "./interaction_form_controller";
import InteractionModalController from "./interaction_modal_controller";
import MultiTagFilterController from "./multi_tag_filter_controller";
import RedirectController from "./redirect_controller";
import QrCustomizerController from "./qr_customizer_controller";
import DropdownController from "./dropdown_controller";
import NotificationsController from "./notifications_controller";

import ModalController from "./modal_controller";
import PerspectiveCropController from "./perspective_crop_controller";
import TagAutocompleteController from "./tag_autocomplete_controller";
import UploadController from "./upload_controller";
import VoiceController from "./voice_controller";
import OnboardingTourController from "./onboarding_tour_controller";
import ClipboardController from "./clipboard_controller";
import AutoSubmitController from "./auto_submit_controller";
import ImageReplaceController from "./image_replace_controller";
import SnoozeModalController from "./snooze_modal_controller";
import TabsController from "./tabs_controller";
import TagManagerController from "./tag_manager_controller";
import LinkChoiceController from "./link_choice_controller";
import ShareController from "./share_controller";
import ProfileTranslationsController from "./profile_translations_controller";

// Register controllers
application.register("auto-dismiss", AutoDismissController);
application.register("calendar-modal", CalendarModalController);
application.register("circle-manager", CircleManagerController);
application.register("contact-picker", ContactPickerController);
application.register("members-modal", MembersModalController);
application.register("contact-form", ContactFormController);
application.register("custom-links", CustomLinksController);
application.register("filter-modal", FilterModalController);
application.register("hello", HelloController);
application.register("interaction-form", InteractionFormController);
application.register("interaction-modal", InteractionModalController);
application.register("multi-tag-filter", MultiTagFilterController);
application.register("redirect", RedirectController);
application.register("qr-customizer", QrCustomizerController);
application.register("dropdown", DropdownController);
application.register("notifications", NotificationsController);

application.register("modal", ModalController);
application.register("perspective-crop", PerspectiveCropController);
application.register("tag-autocomplete", TagAutocompleteController);
application.register("upload", UploadController);
application.register("voice", VoiceController);
application.register("onboarding-tour", OnboardingTourController);
application.register("clipboard", ClipboardController);
application.register("auto-submit", AutoSubmitController);
application.register("image-replace", ImageReplaceController);
application.register("snooze-modal", SnoozeModalController);
application.register("tabs", TabsController);
application.register("tag-manager", TagManagerController);
application.register("link-choice", LinkChoiceController);
application.register("share", ShareController);
application.register("profile-translations", ProfileTranslationsController);
